import { connect } from '@cian/adfox-component';

import { OwnTemplates } from './internal/components/OwnTemplates';

export const AdfoxBanner = connect(OwnTemplates);
